module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl2-100.9f3c7596.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl2-100.png
// module id = 3564
// module chunks = 11